import React from 'react';
import ReactSelect from 'react-select';

import styles from './URLTypeSelect.module.scss';

const linksCustomStyles = {
  container: (base) => ({
    ...base,
    width: 'fit-content',
  }),
  menu: (base) => ({
    ...base,
    zIndex: 5,
  }),
  singleValue: (base) => ({
    ...base,
    color: '#959595',
  }),
  control: (base) => ({
    ...base,
    border: 'none',
    boxShadow: 'none',
    '&:hover': {
      border: 'none',
    },
  }),
  option: (base) => ({
    ...base,
    backgroundColor: '#fff',
    color: '#959595',
    '&:hover': {
      background: '#EEEEEE',
    },
  }),
};

const URLTypeSelect = ({ name, value, onChange, options, defaultValue, isClearable = true, isSearchable = true }) => (
  <div className={styles.container}>
    <ReactSelect
      defaultValue={defaultValue}
      options={options}
      name={name}
      value={value}
      onChange={onChange}
      isClearable={isClearable}
      isSearchable={isSearchable}
      components={{
        IndicatorSeparator: () => null,
      }}
      styles={linksCustomStyles}
    />
  </div>
);

export default URLTypeSelect;
